import { useMemo } from 'react';
import getMeta from '@atlassian/jira-get-meta';

export const useSiteTitle = () =>
	useMemo(
		() => ({
			shouldShow: getMeta('ajs-lf-top-adg3-shouldshowtitle') === 'true',
			value: getMeta('ajs-app-title'),
		}),
		[],
	);
